export default __webpack_public_path__ + "static/media/IMG_1965.15eaeb06.jpg";